/* mes-pdp3-hero.js: Website 3.0 HERO behaviour for the tungsten ring page (Woz, 9 Oct 2026).

   Loaded (defer) by sections/main-product.liquid ONLY when the variant picker block's "Ring picker" or the section's
   "Sticky bar reveal" is switched on. Two independent parts:

   1. RING PICKER (fieldset[data-mes-rp], snippets/mes-pdp3-ring-picker.liquid)
      - keeps the "SIZE · MM · 9 · 18.8 MM / CHOOSE" label true to the CHECKED size radio
      - a tap on a SOLD-OUT size does not select it: it shows "Size N is out right now. Size M is in stock, x.x mm
        bigger." with a "Take M" pill (nearest in-stock size). Same as the design's pickSize().
      - the "Don't know your size?" panel: "Do you already own a ring?" -> YES = on-screen sizer (measure + calibrate,
        px-per-mm in localStorage 'msmz_ppm'), NO = the theme's own ring size guide, opened through its own switch.
      - Add to cart with no size: the theme's product form already fires `mes-pdp3:size-required` on the size guide
        (theme.js); here it opens this panel with "Pick a size first".
      - document `mes:open-size-guide` (fired by the sticky bar and the final CTA): scroll to the size picker, open
        the panel. Pass { detail: { nudge: true } } to also show the nudge line.
      Every size the shopper picks is a real click on the theme's own size radio, so variant selection, price,
      pre-order, the URL, and the Add to cart check stay the theme's. Nothing here submits or touches the cart.

   2. STICKY BAR HEAD REVEAL ([data-mes-satc-reveal]): the bar's name + variant + price row unfolds once the buy box
      price ([data-buy-anchor]) has scrolled ABOVE the screen. IntersectionObserver, no scroll handler.

   Variant changes: listens to the theme's own `variant:change` (CustomEvent on the product <form>, bubbles,
   detail { product, variant, previousVariant }, theme.js VariantPicker.selectVariant). No new event is invented. */
(function () {
  'use strict';
  if (window.__mesPdp3Hero) { return; }
  window.__mesPdp3Hero = true;

  var CARD_MM = 53.98;          /* ISO/IEC 7810 ID-1 bank card, short edge: a physical constant, not a design value */
  var PPM_KEY = 'msmz_ppm';     /* the design's key, so a calibration made on one ring page holds on the others */
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var pickers = [];

  function fill(tpl, vals) {
    return String(tpl == null ? '' : tpl).replace(/\[(\w+)\]/g, function (m, k) { return vals[k] != null ? vals[k] : m; });
  }
  function norm(v) { return String(v == null ? '' : v).trim().toUpperCase(); }
  function fmt(n) { return (Math.round(n * 10) / 10).toFixed(1); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------------------------------------------------------------- 1. ring picker */
  function initPicker(field) {
    var guide = field.querySelector('[data-rp-guide]');
    var cfgEl = guide && guide.querySelector('[data-rp-cfg]');
    if (!guide || !cfgEl) { return null; }
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return null; }
    var map = cfg.map || {};
    var unit = cfg.unit || 'mm';
    /* V9.28.241: sizes are SHOWN in cm (the map and the on-screen sizer stay in mm): rings 2 decimals, kadas 1 */
    var dec = +cfg.dec || 2;
    function disp(m) { return (m / 10).toFixed(dec); }

    /* the size radios of THIS option (not anything inside the panel) */
    var radios = Array.prototype.filter.call(field.querySelectorAll('input[type="radio"]'), function (r) {
      return !guide.contains(r) && r.closest('[data-option-selector]');
    });
    if (!radios.length) { return null; }
    var formId = radios[0].getAttribute('form');
    var picker = field.closest('variant-picker');

    function mmOf(v) { var k = String(v == null ? '' : v).trim(); return Object.prototype.hasOwnProperty.call(map, k) ? +map[k] : null; }
    function labelOf(r) { return r.nextElementSibling; }
    function isOut(r) { var l = labelOf(r); return !!(l && l.classList.contains('is-disabled')); }
    function isOffered(r) { var l = labelOf(r); return !!(l && !l.hidden); }
    function radioFor(v) { var w = norm(v); for (var i = 0; i < radios.length; i++) { if (norm(radios[i].value) === w) { return radios[i]; } } return null; }
    function checkedRadio() { for (var i = 0; i < radios.length; i++) { if (radios[i].checked) { return radios[i]; } } return null; }
    function colourName() {
      var c = picker && picker.querySelector('.mes-rp-opt--colour input[type="radio"]:checked');
      return c ? c.value : '';
    }

    /* ---- labels: "9 · 18.8 MM" / "CHOOSE", and the sticky bar line */
    var sizeLabel = field.querySelector('[data-rp-sizelabel]');
    function renderLabels() {
      var r = checkedRadio();
      var m = r ? mmOf(r.value) : null;
      if (sizeLabel) { sizeLabel.textContent = r ? (r.value + (m != null ? ' · ' + disp(m) + ' ' + unit : '')) : (cfg.choose || ''); }
      var txt = r ? fill(cfg.barSize, { size: r.value, mm: m != null ? disp(m) : '' }) : (cfg.barChoose || '');
      var c = colourName();
      if (c) { txt += ' · ' + c; }
      each(document.querySelectorAll('[data-mes-satc-sizebtn]'), function (b) {
        if (!formId || b.getAttribute('data-form') === formId) { b.textContent = txt; }
      });
    }

    /* ---- sold-out size row */
    var notifyEl = guide.querySelector('[data-rp-notify]');
    var nHead = guide.querySelector('[data-rp-notify-head]');
    var nAlt = guide.querySelector('[data-rp-notify-alt]');
    var nTake = guide.querySelector('[data-rp-take]');
    var nCta = guide.querySelector('[data-rp-notify-cta]');
    var notifyR = null, takeR = null, bypass = false;

    function nearestInStock(r) {
      var base = mmOf(r.value), baseN = parseFloat(r.value), best = null, bestD = Infinity, bestV = -Infinity;
      radios.forEach(function (x) {
        if (x === r || !isOffered(x) || isOut(x)) { return; }
        var m = mmOf(x.value);
        var v = (m != null && base != null) ? m : parseFloat(x.value);
        var d = Math.abs(v - ((m != null && base != null) ? base : baseN));
        if (isNaN(d)) { return; }
        /* nearest first; on a tie the BIGGER size (the design's altFor: a ring a touch loose beats one that will not go on) */
        if (d < bestD - 1e-9 || (Math.abs(d - bestD) < 1e-9 && v > bestV)) { best = x; bestD = d; bestV = v; }
      });
      return best;
    }
    function showNotify(r, fromSlider) {
      notifyR = r;
      radios.forEach(function (x) { var l = labelOf(x); if (l) { l.classList.toggle('is-notify', x === r); } });
      /* the design leaves NO size chosen after a sold-out tap: the same state as the theme's own "no default size",
         so Add to cart asks for a size instead of adding the previous one. Done after this event: when the tap was a
         click ON a radio (the ring guide's slider clicks radios), cancelling it makes the browser restore the group's
         previously checked radio once the event ends, which would undo an uncheck made now. */
      var c = checkedRadio();
      if (c) { c.checked = false; }
      setTimeout(function () {
        if (notifyR !== r) { return; }
        var again = checkedRadio();
        if (again) { again.checked = false; renderLabels(); }
      }, 0);
      if (nHead) { nHead.textContent = fill(cfg.outHead, { size: r.value }); }
      takeR = nearestInStock(r);
      if (takeR) {
        var a = mmOf(takeR.value), b = mmOf(r.value);
        var bigger = (a != null && b != null) ? a > b : parseFloat(takeR.value) > parseFloat(r.value);
        if (nAlt) { nAlt.textContent = fill(cfg.altLine, { alt: takeR.value, diff: (a != null && b != null) ? disp(Math.abs(a - b)) : '', dir: bigger ? cfg.bigger : cfg.smaller }); }
        if (nTake) { nTake.textContent = fill(cfg.take, { alt: takeR.value }); nTake.hidden = false; }
      } else {
        if (nAlt) { nAlt.textContent = ''; }
        if (nTake) { nTake.hidden = true; }
      }
      if (notifyEl) { notifyEl.hidden = false; }
      if (!fromSlider) { syncSizer(mmOf(r.value)); }
      renderLabels();
    }
    function hideNotify() {
      notifyR = null; takeR = null;
      radios.forEach(function (x) { var l = labelOf(x); if (l) { l.classList.remove('is-notify'); } });
      if (notifyEl) { notifyEl.hidden = true; }
    }
    if (nTake) { nTake.addEventListener('click', function () { if (takeR) { takeR.click(); } }); }
    if (nCta) {
      /* "Tell me when it's back": select the sold-out size for real, so the store's restock app shows its Notify Me */
      nCta.addEventListener('click', function () {
        var r = notifyR;
        if (!r) { return; }
        bypass = true;
        try { r.click(); } finally { bypass = false; }
        hideNotify();
        renderLabels();
      });
    }

    /* a sold-out size is tappable but is not selected (capture phase, before the label activates its radio) */
    field.addEventListener('click', function (e) {
      if (bypass) { return; }
      var t = e.target, r = null;
      if (t && t.tagName === 'INPUT' && radios.indexOf(t) > -1) { r = t; }
      else {
        var l = t && t.closest ? t.closest('label') : null;
        if (l && l.htmlFor) { var cand = document.getElementById(l.htmlFor); if (radios.indexOf(cand) > -1) { r = cand; } }
      }
      if (!r || !isOut(r)) { return; }
      e.preventDefault();
      showNotify(r, false);
    }, true);

    /* ---- the panel */
    var toggleBtn = guide.querySelector('[data-rp-toggle]');
    var nudgeEl = guide.querySelector('[data-rp-nudge]');
    var askEl = guide.querySelector('[data-rp-ask]');
    var fitHead = guide.querySelector('[data-rp-fithead]');
    var fitRingLab = guide.querySelector('[data-rp-fitlabel-ring]');
    var fitFingerLab = guide.querySelector('[data-rp-fitlabel-finger]');
    var ringBox = guide.querySelector('[data-rp-ring]');
    var fingerBox = guide.querySelector('[data-rp-finger]');
    var sgToggle = fingerBox && fingerBox.querySelector('[data-mes-sg-toggle]');
    var isOpen = false, fit = null;
    /* Shrey 10 Oct: the on-screen ring match needs a ring laid on the screen, which only works on a phone or tablet
       (a touch screen as the main pointer). On desktop the panel skips the question and opens the usual size guide. */
    var canSizer = true; try { canSizer = matchMedia('(pointer: coarse)').matches; } catch (e) {}
    if (!canSizer) { guide.classList.add('is-nosizer'); }

    function setNudge(on) { if (nudgeEl) { nudgeEl.hidden = !on; } }
    function setOpen(open) {
      isOpen = !!open;
      guide.classList.toggle('is-open', isOpen);
      if (toggleBtn) { toggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false'); }
      if (!isOpen) { setNudge(false); }
      if (isOpen && !canSizer && fit !== 'finger') { setFit('finger'); }
    }
    /* the theme's ring guide (mes-size-guide.js) is open when it has put .mes-sg-open on this fieldset */
    function guideOpen() { return field.classList.contains('mes-sg-open'); }
    function ensureGuide(want) { if (sgToggle && guideOpen() !== want) { sgToggle.click(); } }
    function setFit(k) {
      fit = k;
      if (askEl) { askEl.hidden = !!k; }
      if (fitHead) { fitHead.hidden = !k; }
      if (fitRingLab) { fitRingLab.hidden = k !== 'ring'; }
      if (fitFingerLab) { fitFingerLab.hidden = k !== 'finger'; }
      if (ringBox) { ringBox.hidden = k !== 'ring'; }
      if (fingerBox) { fingerBox.hidden = k !== 'finger'; }
      /* the guide measures its own height when it opens, so its box must be showing first (it is, just above) */
      ensureGuide(k === 'finger');
      if (k === 'ring') { paintSizer(); }
      if (k === 'ring' && isKada && canSizer) { openFull(); if (lockMeasure()) { setMode('calib'); } }
    }
    /* V9.28.234 (Shrey, 21 Oct): the KADA sizer opens FULL SCREEN, so the curve can use the phone's whole height.
       The sizer box itself is MOVED into an overlay on <body> (an ancestor with overflow or a transform would trap a
       position:fixed child) and moved back on Done, so every listener and value travels with it. The overlay re-creates
       the two ancestors the styles key on (.mes-pdp3 > .mes-rp.mes-rp--kada) and copies the --rp-* colours, which are
       set on the product section and would not reach <body>. Done closes the panel; the size it matched stays picked. */
    var isKada = guide.getAttribute('data-rp-kind') === 'kada';
    var fullWrap = null, fullHome = null;
    function openFull() {
      if (fullWrap || !ringBox) { return; }
      var cs = getComputedStyle(ringBox);
      fullWrap = document.createElement('div');
      fullWrap.className = 'mes-pdp3 mes-rp-fullwrap';
      fullWrap.setAttribute('role', 'dialog');
      fullWrap.setAttribute('aria-modal', 'true');
      fullWrap.setAttribute('aria-label', fitRingLab ? fitRingLab.textContent.trim() : 'Size');
      ['--rp-ink', '--rp-muted', '--rp-sub', '--rp-sel', '--rp-line', '--rp-panel'].forEach(function (v) {
        var val = cs.getPropertyValue(v); if (val) { fullWrap.style.setProperty(v, val.trim()); }
      });
      var inner = document.createElement('div');
      inner.className = 'mes-rp mes-rp--kada mes-rp-full';
      var head = document.createElement('div');
      head.className = 'mes-rp-full__head';
      var title = document.createElement('span');
      title.className = 'mes-rp-fithead__label';
      title.textContent = fitRingLab ? fitRingLab.textContent.trim() : '';
      var done = document.createElement('button');
      done.type = 'button';
      done.className = 'mes-rp-full__done';
      done.textContent = guide.getAttribute('data-rp-done') || 'Done';
      done.addEventListener('click', closeFull);
      head.appendChild(title); head.appendChild(done);
      inner.appendChild(head);
      fullHome = document.createComment('mes-rp-ring');
      ringBox.parentNode.insertBefore(fullHome, ringBox);
      inner.appendChild(ringBox);
      fullWrap.appendChild(inner);
      document.body.appendChild(fullWrap);
      document.documentElement.classList.add('mes-rp-locked');
      document.addEventListener('keydown', onFullKey);
      paintSizer();
      try { done.focus({ preventScroll: true }); } catch (e) {}
    }
    function onFullKey(e) { if (e.key === 'Escape') { closeFull(); } }
    function closeFull() {
      if (!fullWrap) { return; }
      if (fullHome && fullHome.parentNode) { fullHome.parentNode.insertBefore(ringBox, fullHome); fullHome.parentNode.removeChild(fullHome); }
      fullWrap.parentNode && fullWrap.parentNode.removeChild(fullWrap);
      fullWrap = null; fullHome = null;
      document.documentElement.classList.remove('mes-rp-locked');
      document.removeEventListener('keydown', onFullKey);
      setFit(null);
      setOpen(false);
      try { field.scrollIntoView({ block: 'center' }); } catch (e) {}
    }
    if (toggleBtn) { toggleBtn.addEventListener('click', function () { setOpen(!isOpen); }); }
    each(guide.querySelectorAll('[data-rp-pick]'), function (b) {
      b.addEventListener('click', function () { setFit(b.getAttribute('data-rp-pick')); });
    });
    var changeBtn = guide.querySelector('[data-rp-change]');
    if (changeBtn) { changeBtn.addEventListener('click', function () { setFit(null); }); }

    /* ---- on-screen sizer */
    var range = guide.querySelector('[data-rp-range]');
    var ppmRange = guide.querySelector('[data-rp-ppm]');
    var circle = guide.querySelector('[data-rp-circle]');
    var circleLab = guide.querySelector('[data-rp-circle-label]');
    var mmRead = guide.querySelector('[data-rp-mmread]');
    var matchEl = guide.querySelector('[data-rp-match]');
    var cardBar = guide.querySelector('[data-rp-cardbar]');
    /* a ring or card held on the circle / card bar must not scroll the page (Priyanka, H542); touch-action covers most browsers,
       this covers older iOS that ignores it */
    each(guide.querySelectorAll('.mes-rp-circle, .mes-rp-cardbar'), function (st) {
      st.addEventListener('touchmove', function (e) { if (e.cancelable) { e.preventDefault(); } }, { passive: false });
    });
    var keys = Object.keys(map).filter(function (k) { return +map[k] > 0; }).sort(function (a, b) { return map[a] - map[b]; });
    var mmMin = keys.length ? +map[keys[0]] : 16.4;
    var mmMax = keys.length ? Math.round((+map[keys[keys.length - 1]] + 0.4) * 10) / 10 : 22.6;
    /* V9.28.245 (Priyanka, 21 Oct: "circle is too big from the start" on an Android): screen pixels per mm.
       (1) The phone default is no longer one number (6.2 suits an iPhone): phone screens are about 64-72 mm wide whatever
       their CSS width, so pixels-per-mm is estimated as the screen's CSS width / 67 mm, clamped to 5.0-6.6 (360 px wide
       -> 5.4; iPhone 14 390 -> 5.8; Pixel 7 412 -> 6.1). (2) A remembered calibration is used only if it is plausible for
       a phone (4.5-7.5): the old slider allowed 3.5-9 and a stray drag was remembered for every later visit. */
    var PPM_LO = 4.5, PPM_HI = 7.5;
    var isPhone = window.innerWidth < 700;
    var ppm = (function () {
      var sw = (window.screen && Math.min(window.screen.width, window.screen.height)) || window.innerWidth;
      var def = isPhone ? Math.min(6.6, Math.max(5.0, sw / 67)) : (+cfg.ppmDesktop || 3.78);
      try {
        var s = parseFloat(window.localStorage.getItem(PPM_KEY));
        if (s > 0 && (!isPhone || (s >= PPM_LO && s <= PPM_HI))) { return s; }
      } catch (e) {}
      return Math.round(def * 50) / 50;
    })();
    var startR = checkedRadio();
    var mm = (startR && mmOf(startR.value) != null) ? mmOf(startR.value) : Math.min(mmMax, Math.max(mmMin, 19.6));
    var lastN = null, fromSlider = false;

    if (range) { range.min = String(mmMin); range.max = String(mmMax); range.value = String(mm); }
    if (ppmRange) { if (isPhone) { ppmRange.min = String(PPM_LO); ppmRange.max = String(PPM_HI); } ppmRange.value = String(ppm); }

    function nearestKey(v) {
      var best = null, d = Infinity;
      keys.forEach(function (k) { var dd = Math.abs(+map[k] - v); if (dd < d) { d = dd; best = k; } });   /* tie -> the smaller, as the design's nearest() */
      return best;
    }
    function offeredSorted() {
      return radios.filter(function (r) { return isOffered(r) && mmOf(r.value) != null; })
        .sort(function (a, b) { return mmOf(a.value) - mmOf(b.value); });
    }
    function paintSizer() {
      var px = Math.round(mm * ppm);
      if (circle) { circle.style.width = px + 'px'; circle.style.height = px + 'px'; }
      var lab = disp(mm) + ' ' + unit;
      if (circleLab) { circleLab.textContent = lab; }
      if (mmRead) { mmRead.textContent = lab; }
      if (cardBar) { cardBar.style.width = Math.round(CARD_MM * ppm) + 'px'; }
      if (!matchEl) { return; }
      var n = nearestKey(mm), r = n != null ? radioFor(n) : null;
      if (n == null) { matchEl.textContent = ''; return; }
      if (!r || !isOffered(r)) {
        var o = offeredSorted();
        /* V9.28.233: one offered size reads "size 8 only", not "8 to 8" */
        var one = o.length && o[0].value === o[o.length - 1].value;
        matchEl.textContent = o.length ? fill(one && cfg.matchOnly ? cfg.matchOnly : cfg.matchRange, { size: n, min: o[0].value, max: o[o.length - 1].value }) : '';
      } else if (isOut(r)) {
        matchEl.textContent = fill(cfg.matchOut, { size: n });
      } else {
        matchEl.textContent = fill(cfg.match, { size: n });
      }
    }
    function syncSizer(v) {
      if (v == null || isNaN(v)) { return; }
      mm = v; lastN = nearestKey(v);
      if (range) { range.value = String(v); }
      if (fit === 'ring') { paintSizer(); }
    }
    if (range) {
      range.addEventListener('input', function () {
        mm = parseFloat(range.value);
        paintSizer();
        var n = nearestKey(mm);
        if (n == null || n === lastN) { return; }
        lastN = n;
        var r = radioFor(n);
        if (!r || !isOffered(r) || r.checked) { return; }
        /* sold out: the "nearest size" row, and the slider stays under the finger (the design's onRange) */
        if (isOut(r)) { showNotify(r, true); return; }
        /* in stock: a real click on the theme's own radio; fromSlider stops the change handler snapping the slider back */
        fromSlider = true;
        r.click();
      });
    }
    if (ppmRange) {
      ppmRange.addEventListener('input', function () {
        var v = parseFloat(ppmRange.value);
        if (!(v > 0)) { return; }
        ppm = v;
        try { window.localStorage.setItem(PPM_KEY, String(v)); } catch (e) {}
        paintSizer();
      });
    }
    /* V9.28.246 (Shrey A1522, 21 Oct): on a KADA the shopper cannot measure until the screen is calibrated with a bank card:
       "they should not be able to measure their kada incorrectly". The first visit opens on Calibrate with Measure locked;
       "My card matches" confirms it, remembers it on this phone (CAL_KEY) and moves on to Measure. Rings are unchanged. */
    var CAL_KEY = 'msmz_ppm_set';
    var calibrated = false;
    try { calibrated = window.localStorage.getItem(CAL_KEY) === '1'; } catch (e) {}
    function lockMeasure() {
      var locked = isKada && !calibrated;
      each((ringBox || guide).querySelectorAll('[data-rp-mode="measure"]'), function (t) {
        t.disabled = locked; t.setAttribute('aria-disabled', locked ? 'true' : 'false');
      });
      return locked;
    }
    function setMode(mode) {
      var scope = ringBox || guide;
      var b = scope.querySelector('[data-rp-mode="' + mode + '"]');
      if (b) { b.click(); }
    }
    var calOk = guide.querySelector('[data-rp-calib-ok]');
    if (calOk) {
      calOk.addEventListener('click', function () {
        calibrated = true;
        try { window.localStorage.setItem(CAL_KEY, '1'); window.localStorage.setItem(PPM_KEY, String(ppm)); } catch (e) {}
        lockMeasure();
        setMode('measure');
      });
    }
    each(guide.querySelectorAll('[data-rp-mode]'), function (b) {
      b.addEventListener('click', function () {
        var mode = b.getAttribute('data-rp-mode');
        if (mode === 'measure' && lockMeasure()) { return; }
        /* V9.28.243 (Shrey, 21 Oct): search from the SIZER BOX, not the panel: in the kada's full-screen view the box is
           moved out of the panel into the overlay, so the panel no longer contains the tabs or the views and the switch
           silently did nothing (measured on Shrey's Android). */
        var scope = ringBox || guide;
        each(scope.querySelectorAll('[data-rp-mode]'), function (x) {
          var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        each(scope.querySelectorAll('[data-rp-view]'), function (v) { v.hidden = v.getAttribute('data-rp-view') !== mode; });
        paintSizer();
      });
    });

    /* ---- the theme's events */
    field.addEventListener('change', function (e) {
      if (radios.indexOf(e.target) < 0) { return; }
      hideNotify();
      setNudge(false);
      if (!fromSlider) { syncSizer(mmOf(e.target.value)); }
      fromSlider = false;
      renderLabels();
    });
    /* Add to cart with no size (theme.js -> [data-mes-sg] -> bubbles here). mes-size-guide.js, which handles it first,
       opens ITS guide and scrolls to this option; the guide stays open only when the shopper is on the "No ring yet" path. */
    field.addEventListener('mes-pdp3:size-required', function () {
      setOpen(true);
      setNudge(true);
      setTimeout(function () { if (fit !== 'finger') { ensureGuide(false); } }, 0);
    });
    /* colour changed: availability per size may differ; the theme re-checks the size radios after it dispatches, so read next task */
    document.addEventListener('variant:change', function (e) {
      /* getAttribute, not .id: a product form holds <input name="id">, so form.id is that INPUT, never the string */
      if (formId && e.target && e.target.getAttribute && e.target.getAttribute('id') !== formId) { return; }
      setTimeout(function () {
        hideNotify();
        renderLabels();
        if (fit === 'ring') { paintSizer(); }
      }, 0);
    });

    renderLabels();

    return {
      field: field,
      open: function (detail) {
        var off = 16;
        try { off += parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0; } catch (e) {}
        var top = field.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - off;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
        setOpen(true);
        if (detail && detail.nudge && !checkedRadio()) { setNudge(true); }
      }
    };
  }

  /* `mes:open-size-guide`: the one entry point the sticky bar and the final CTA use. Without the ring picker it falls
     back to the theme's own V3 size guide (same event the Add to cart check fires: open, scroll, flash). */
  document.addEventListener('mes:open-size-guide', function (e) {
    if (pickers.length) { pickers[0].open(e && e.detail); return; }
    var sg = document.querySelector('.mes-pdp3 [data-mes-sg]');
    if (sg) { sg.dispatchEvent(new CustomEvent('mes-pdp3:size-required', { bubbles: true })); }
  });

  /* ---------------------------------------------------------------- 2. sticky bar head reveal */
  function initBar(wrap) {
    if (wrap.dataset.mesRevealBound) { return; }
    wrap.dataset.mesRevealBound = '1';
    var btn = wrap.querySelector('[data-mes-satc-sizebtn]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('mes:open-size-guide', { detail: { source: 'sticky-bar' } }));
      });
    }
    var anchor = document.querySelector('.mes-pdp3 [data-buy-anchor]') || document.querySelector('[data-buy-anchor]');
    /* fail open: no anchor, no IntersectionObserver, or an anchor that is not laid out -> the row simply shows */
    if (!anchor || !('IntersectionObserver' in window) || !anchor.getClientRects().length) {
      wrap.classList.add('is-head-on');
      return;
    }
    new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      wrap.classList.toggle('is-head-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  function boot() {
    each(document.querySelectorAll('fieldset[data-mes-rp]'), function (f) {
      if (f.dataset.mesRpBound) { return; }
      f.dataset.mesRpBound = '1';
      var p = initPicker(f);
      if (p) { pickers.push(p); }
    });
    each(document.querySelectorAll('[data-mes-satc-reveal]'), initBar);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
